{
  "name": "supervisore360",
  "version": "3.3.1",
  "description": "WebAppllication Supervisore360",
  "scripts": {
    "update-commit-hash": "node ./node_modules/@aruba/common-lib/bin/update-environment-commit-hash.js src/environments/environment.ts",
    "prebuild": "npm run update-commit-hash",
    "install-project": "npm install",
    "ng": "ng",
    "start:it:dev": "npm run generate-config --country=it --environment=dev && ng serve --configuration=it-dev",
    "start:it:test": "npm run generate-config --country=it --environment=test && ng serve --configuration=it-test",
    "start:it:prod": "npm run generate-config --country=it --environment=prod && ng serve --configuration=it-prod",
    "start:pl:dev": "npm run generate-config --country=pl --environment=dev && ng serve --configuration=pl-dev",
    "start:pl:test": "npm run generate-config --country=pl --environment=test && ng serve --configuration=pl-test",
    "start:pl:prod": "npm run generate-config --country=pl --environment=prod && ng serve --configuration=pl-prod",
    "build:it:dev": "npm run generate-config --country=it --environment=dev && ng build --configuration=it-dev",
    "build:it:test": "npm run generate-config --country=it --environment=test && ng build --configuration=it-test",
    "build:it:prod": "npm run generate-config --country=it --environment=prod && ng build --configuration=it-prod",
    "build:pl:dev": "npm run generate-config --country=pl --environment=dev && ng build --configuration=pl-dev",
    "build:pl:test": "npm run generate-config --country=pl --environment=test && ng build --configuration=pl-test",
    "build:pl:prod": "npm run generate-config --country=pl --environment=prod && ng build --configuration=pl-prod",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "link-all": "npm link file:../librerie-trasversali/dist/angular-morningStar file:../librerie-trasversali/node_modules/@morningstar/morningstar file:../librerie-trasversali/dist/aruba-common-lib file:../librerie-trasversali/node_modules/ng2-pdf-viewer file:../librerie-trasversali/node_modules/pdfjs-dist",
    "install-link": "npm run install-project && npm run link-all",
    "test": "npx jest --runInBand",
    "test:dev": "npx jest --runInBand --logHeapUsage",
    "test:watch": "npx jest --runInBand --watch",
    "generate-config": "cross-var node generate-config.js",
    "prettier-write": "prettier --write \"**/*.{ts,html}\"",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run",
    "crowdin-upload": "crowdin upload --config crowdin.yml --verbose",
    "crowdin-download": "crowdin download --config crowdin.yml --verbose",
    "crowdin-status": "crowdin status --config crowdin.yml --verbose",
    "crowdin-sync": "npm run crowdin-upload && npm run crowdin-download --verbose",
    "crowdin-clear": "crowdin clear --config crowdin.yml --verbose",
    "crowdin-clean": "crowdin clean --config crowdin.yml --verbose",
    "i18n:find": "transloco-keys-manager find -i src/app -p ./src/assets/i18n",
    "i18n:extract": "transloco-keys-manager extract -i src/app -o ./src/assets/i18n --sort --unflat --remove-extra-keys --add-missing-keys"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.8",
    "@angular/cdk": "^21.2.6",
    "@angular/common": "^21.2.8",
    "@angular/compiler": "^21.2.8",
    "@angular/core": "^21.2.8",
    "@angular/forms": "^21.2.8",
    "@angular/material": "^21.2.6",
    "@angular/material-moment-adapter": "^21.2.6",
    "@angular/platform-browser": "^21.2.8",
    "@angular/platform-browser-dynamic": "^21.2.8",
    "@angular/router": "^21.2.8",
    "@aruba/angular-morningstar": "5.0.3",
    "@aruba/common-lib": "5.0.3",
    "@jsverse/transloco": "^8.3.0",
    "@jsverse/transloco-messageformat": "^8.3.0",
    "@jsverse/transloco-persist-lang": "^8.3.0",
    "@ngrx/effects": "^21.1.0",
    "@ngrx/operators": "^21.1.0",
    "@ngrx/store": "^21.1.0",
    "@ngrx/store-devtools": "^21.1.0",
    "angular-oauth2-oidc": "^20.0.0",
    "filter-data": "^0.6.1",
    "just-clone": "^6.2.0",
    "moment": "^2.30.1",
    "ng-recaptcha-2": "^21.0.0",
    "ngrx-immer": "^4.1.1",
    "rxjs": "~7.8.0",
    "sha.js": "^2.4.11",
    "sort-array": "^5.1.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.7",
    "@angular/cli": "~21.2.7",
    "@angular/compiler-cli": "^21.2.8",
    "@casualbot/jest-sonar-reporter": "^2.4.0",
    "@crowdin/cli": "^4.13.0",
    "@jsverse/transloco-keys-manager": "^6.2.2",
    "@tailwindcss/typography": "^0.5.10",
    "@types/jest": "^30.0.0",
    "@types/moment": "^2.13.0",
    "@types/sha.js": "^2.4.4",
    "@types/sort-array": "^4.1.2",
    "autoprefixer": "^10.4.14",
    "cross-var": "^1.1.0",
    "cypress": "^15.13.0",
    "jest": "^30.3.0",
    "jest-environment-jsdom": "^30.3.0",
    "jest-junit": "^16.0.0",
    "jest-preset-angular": "^16.0.0",
    "jest-util": "^30.3.0",
    "jsdom-testing-mocks": "^1.16.0",
    "postcss": "^8.4.27",
    "prettier": "^3.8.0",
    "tailwindcss": "^3.3.3",
    "ts-node": "^10.9.2",
    "ts-jest": "^29.2.5",
    "typescript": "~5.9.3"
  }
}
